import React, { FC } from 'react';
import { NavLink } from 'react-router';
import { cn } from '../utils';

type Props = {
  to: string;
  children: React.ReactNode;
  active: boolean;
};

const PaginationPage: FC<Props> = ({ to, active, children }) => {
  return (
    <NavLink
      to={to}
      className={cn(
        `
          flex h-10 w-10 items-center justify-center rounded-full border border-[#D7EAEF]
          bg-[radial-gradient(421.88%_421.88%_at_50%_50%,_#002135_0%,_#96D1F6_100%)] text-base
          text-white shadow-[0px_-4px_8px_0px_#99D6FB1A_inset] shadow-[0px_0px_2px_0px_#96D1F5]
          backdrop-blur-[8px]
        `,
        active &&
          `
            border-[#91F800]
            bg-[radial-gradient(421.88%_421.88%_at_50%_50%,_#002135_0%,_#91F800_100%)]
          `,
      )}
    >
      {children}
    </NavLink>
  );
};

export default PaginationPage;
